import script from "./sf-drag-handle.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-drag-handle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__